import { Routes } from '@angular/router';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { authGuard } from './core/guards/auth.guard';
import { userResolver } from './core/services/resolvers/user.resolver';
import { languageGuard } from './core/guards/language.guard';

export const APP_ROUTES: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [languageGuard, authGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pool-settings/pool-settings.routes').then(
            (mod) => mod.POOL_SETTINGS_ROUTES,
          ),
      },
      {
        path: 'finance',
        loadChildren: () =>
          import('./finance/finance.routes').then((mod) => mod.FINANCE_ROUTES),
        resolve: [userResolver],
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./users/users.routes').then((mod) => mod.USERS_ROUTES),
        resolve: [userResolver],
      },
      {
        path: 'roles',
        loadComponent: () =>
          import('./roles-section/ui').then((mod) => mod.RolesSectionComponent),
        resolve: [userResolver],
      },
      {
        path: 'system-notifications',
        loadComponent: () =>
          import('./system-notification/system-notification.component').then(
            (mod) => mod.SystemNotificationComponent,
          ),
        resolve: [userResolver],
      },
    ],
  },
  {
    path: 'login',
    title: 'RedRock Pool - Вход',
    canActivate: [languageGuard],
    loadChildren: () =>
      import('./auth/auth.routes').then((mod) => mod.AUTH_ROUTES),
  },
];
